import React from 'react';
import { Legend, PolarAngleAxis, PolarGrid, PolarRadiusAxis, Radar, RadarChart, ResponsiveContainer } from 'recharts';

const OrgSurveyCompareRadarChart = ({ data }) => {
    // console.log(JSON.stringify(data));
    const uniqueKeys = data.shift(); // removes the first row from the data set to be used by the chart
    return (
        uniqueKeys ?.length > 1 ?
            <React.Fragment>
                <ResponsiveContainer width="100%" height={600}>
                    <RadarChart outerRadius={150} data={data}>
                        <Radar name="Survey 1" dataKey={uniqueKeys[0]} stroke="#ffc658" fill="#ffc658" fillOpacity={0.6} />
                        <Radar name="Survey 2" dataKey={uniqueKeys[1]} stroke="#3367d6" fill="#3367d6" fillOpacity={0.6} />
                        <PolarGrid />
                        <Legend />
                        <PolarAngleAxis dataKey="question" />
                        <PolarRadiusAxis angle={45} domain={[0, 9]} />
                    </RadarChart>
                </ResponsiveContainer>;
        </React.Fragment>
            : <React.Fragment></React.Fragment>
    );
};

export default OrgSurveyCompareRadarChart;


// WEBPACK FOOTER //
// ./components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyCompareRadar/Components/OrgSurveyCompareRadarChart.js